<template>
		<div>
            <v-icon v-if="estatus == 'B'"
            color="green"
            @click="mostrarDialogo=true">
                mdi-account-key
            </v-icon>

            <v-icon v-else
            color="red"
            @click="mostrarDialogo=true">
                mdi-account-lock
            </v-icon>

            <v-dialog v-model="mostrarDialogo" max-width="450px">

                <v-card>

                    <v-card-title class="d-flex justify-center">
                        <h3 class="mx-3"> ¿Cambiar estatus usuario?</h3>
                    </v-card-title>

                    <v-spacer/>

                    <v-card-text class="d-flex justify-center">
                         <span class="px-2 font-weight-bold text-subtitle-1 text--primary"> ¿ Dar de 
                            <span :class="[clase]">{{mensajeAccion}}</span> 
                                el usuario 
                            <span class="mx-1" :class="[clase]">
                                {{usuario}}
                            </span>?</span>
                    </v-card-text>

                    <v-spacer></v-spacer>

                    <div class="d-flex justify-center">

                        <v-card-actions class="mx-2 my-1">
                            <v-btn text class="grey darken-1" dark @click="mostrarDialogo = false">
                                Cancelar
                            </v-btn>
                            <v-btn text class="primary darken-1" dark @click="cambiarEstatus">
                                Cambiar
                            </v-btn>
                        </v-card-actions>
                    </div>

                </v-card>

            </v-dialog>
        </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
    props: ['infoUsuario'],

    data() {
        return {
            mostrarDialogo:false,

            usuario:    this.infoUsuario.USUARIO,
            estatus:    this.infoUsuario.ESTATUS,

            mensajeAccion:'',
            clase:'',

        }
    },
    computed: {
        ...mapGetters(['getURLAPI','getUsuario','getFechaActual']),
    },

    methods: {

        cambiarEstatus() {
            if ( this.infoUsuario.ESTATUS == 'B' ) {
                const datos = {
                    ESTATUS:                    'A',
                    USUARIO_ID : this.infoUsuario.USUARIO_ID,
                    USUARIO_MODIFICACION:       this.getUsuario,
                    FECHA_HORA_MODIFICACION:    this.getFechaActual
                }

                axios.post(`${this.getURLAPI}/Usuarios/estatusUsuario/${this.infoUsuario.USUARIO_ID}`, datos)
                .then ( (res) => {
                    this.$emit('mostrarSnackbar', res.data ); // se adjunta con argumentos;
                    this.$emit('actualizarTabla')
                    this.mostrarDialogo = false;
                })
            }
            else {
                const datos = {
                    ESTATUS:'B',
                    USUARIO_ID : this.infoUsuario.USUARIO_ID,
                    USUARIO_MODIFICACION: this.getUsuario,
                    FECHA_HORA_MODIFICACION: this.getFechaActual
                }
                axios.post(`${this.getURLAPI}/Usuarios/estatusUsuario`,datos)
                .then( ( res ) => {

                    this.$emit('mostrarSnackbar', res.data ); // se adjunta con argumentos
                    this.$emit('actualizarTabla')
                    this.mostrarDialogo = false;
                    
                })
            }
        }
    },


    created() {
        
        // COLOR DE LA CLASE A USAR Y EL MENSAJE CAMBIA DEPENDIENDO DEL ESTATUS RECIBIDO
        if(this.infoUsuario.ESTATUS == 'A'){
            this.mensajeAccion = 'baja';
            this.clase = 'red--text text--darken-3'
        } else {
            this.mensajeAccion = 'alta';
            this.clase = 'green--text text--darken-3'
        }
    },
}
</script>

<style>

</style>